import { render } from "./eventCard.vue?vue&type=template&id=05f02267&scoped=true"
import script from "./eventCard.vue?vue&type=script&lang=js"
export * from "./eventCard.vue?vue&type=script&lang=js"

import "./eventCard.vue?vue&type=style&index=0&id=05f02267&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f02267"]])

export default __exports__